/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { logErrorToDatabase, postToController } from '../../actions/apiActions';
import { navigateTo } from '../../actions/navigationActions';
import { submitClaimMobile, setLocation, setTimeShow, setTime, checkDateTime, checkDuplicateClaim, clearSelectedDamages, getDateString, resetFNOL, setStep, setFnolReducerPayload } from '../../actions/claimSubmitActions';
import { Dropdown } from 'react-bootstrap';
import DatePicker from '../DatePicker/DatePicker';
import { SUBMIT_CLAIM_DETAILS, SUBMIT_CLAIM_COMPLETE, FNOL, FNOL_SUBMIT_CLAIM } from '../../routes/routes';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { DASHBOARD } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { validateCellphoneNumber, validateSurname } from '../../constants/validation';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { showFNOLSubmitModal, showDuplicateClaim } from '../../actions/modalActions';
import TimeKeeper from 'react-timekeeper';
import Geocode from "react-geocode";

var lat = null
var lng = null

class ClaimDetails extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            eventTypeList: null,
            selectedCover: null,
            selectedEvent: null,
            incidentTypeList: null,
            selectedIncidentType: null,
            coverToggle: false,
            IncidentToggle: false,
            IncidentTypeToggle: false,
            indidentDate: '12:00pm',
            IsIncidentDateClicked: false,
            incidentDescription: "",
            currentStep: 1,
            nextDisabled: true,
            submitDisabled: false,
            showMarker: false,
            claimNumber: "",
            carDriveableSet: false,
            isDriveable: false,
            carRecoveredSet: false,
            isRecovered: false,
            carRecoveredValidationVisible: false,
            carDriveableValidationVisible: false,
            name: this.props.profile.name + "  " + this.props.profile.surname,
            contact: this.props.profile.cellphoneNumber,
            selectedIncidentTypeValidationVisible: false,
            incidentDescriptionValidationVisible: false,
            nameValidationVisible: false,
            contactValidationVisible: false,
            IsIncidentDateValidationVisible: false,
            lat: 0,
            lng: 0,
            mouseOut: false,
            time24: "12:00",
            time12: "12:00 pm",
            hasTime: false,
            hasTimeChanged: false,
            isDuplicate: false,
            isClosed: false,
            hasFutureDate: false,
            hasFutureTime: false,
            stepSubmitted: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleNextMobile = this.handleNextMobile.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleIncidentTypeDropdownToggle = this.handleIncidentTypeDropdownToggle.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleIncidentSelection = this.handleIncidentSelection.bind(this);
        this.handleIncidentToggle = this.handleIncidentToggle.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleIncidentEventTypeSelection = this.handleIncidentEventTypeSelection.bind(this);
        this.handeCanDrive = this.handeCanDrive.bind(this);
        this.handeCanRecover = this.handeCanRecover.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.Submit = this.Submit.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.handleAdressSelect = this.handleAdressSelect.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.checkTimeToggle = this.checkTimeToggle.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.setMouseOut = this.setMouseOut.bind(this);
        this.setMouseIn = this.setMouseIn.bind(this);
        this.listenAwayClick = this.listenAwayClick.bind(this);
        this.setTime = this.setTime.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        Geocode.setApiKey("AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8");
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchSetTimeShow();
        }
    }

    checkTimeToggle() {
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchSetTimeShow();
        }
    }

    async setTime(f12: any, f24: any) {
        await this.setState({ time12: f12, time24: f24 });
        await this.props.dispatchSetTime(f12, f24)
        this.props.dispatchSetTimeShow();
        this.setState({ hasTime: true });
    }

    async setMouseOut() {
        await this.setState({ mouseOut: true });
        this.listenAwayClick();
    }

    async setMouseIn() {
        await this.setState({ mouseOut: false });
        this.listenAwayClick();
    }

    listenAwayClick() {
        if (this.state.mouseOut && !this.state.isClosed) {
            document.body.addEventListener("click", this.handleClickAway);
        }
        else {
            document.body.removeEventListener("click", this.handleClickAway);
        }
    }

    async handleClickAway() {
        document.body.removeEventListener("click", this.handleClickAway);
        this.setState({
            isClosed: true,
        })
        if (this.state.hasTime) {
            await this.setTime(this.state.time12, this.state.time24);
        }
        else {
            this.props.dispatchSetTimeShow();
        }
    }

    async handleTimeChange(f12: any, f24: any) {
        this.setState({ hasTime: true });
        await this.setState({ time12: f12, time24: f24 });
    }

    async updateLatLngAdress(Lat, Lng, address, addressDetails) {
        lat = Lat
        lng = Lng
        await this.setState({ lat: Lat, lng: Lng, adressSelect: addressDetails.formatted, addressDetail: addressDetails });
        this.props.dispatchAction(setFnolReducerPayload({ addressLat: Lat, addressLon: Lng, address: addressDetails.formatted, addressDetail: addressDetails }));
    };

    handleAdressChange = address => {
        this.setState({ adressSelect: address });
    };

    handleAdressSelect = address => {
        let addressDetails = { province: "", city: "", suburb: "", formatted: "", postalCode: "" }
        geocodeByAddress(address)
            .then(async (results) => {
                let latlong = await getLatLng(results[0]);
                let streetNumber, streetName, suburb, city, state, country, postal_code;
                const address = results[0];
                for (let i = 0; i < address.address_components.length; i++) {
                    for (let j = 0; j < address.address_components[i].types.length; j++) {
                        switch (address.address_components[i].types[j]) {
                            case "street_number":
                                streetNumber = address.address_components[i].long_name;
                                break;
                            case "route":
                                streetName = address.address_components[i].long_name;
                                break;
                            case "sublocality":
                                suburb = address.address_components[i].long_name;
                                break;
                            case "locality":
                                city = address.address_components[i].long_name;
                                break;
                            case "administrative_area_level_1":
                                state = address.address_components[i].long_name;
                                break;
                            case "country":
                                country = address.address_components[i].long_name;
                                break;
                            case "postal_code":
                                postal_code = address.address_components[i].long_name;
                                break;
                        }
                    }
                }
                addressDetails = { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted: address.formatted_address, postalCode: postal_code?.toUpperCase() }
                this.setState({ lat: latlong.lat, lng: latlong.lng, addressSelect: address, addressDetail: addressDetails });
                this.updateLatLngAdress(latlong.lat, latlong.lng, address, addressDetails)
            })
            .catch((err) => { logErrorToDatabase("Error retrieving geoCode by Address: " + address + ": " + err) });
    };

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    async handleSubmit(e: any) {
        await this.setState({ stepSubmitted: true });

        var dateString = getDateString(this.props.claimSubmit.incidentDate, this.props.claimSubmit.time);
        var futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));
        if (futureDateTimeCheck) {
            this.setState({
                hasFutureTime: futureDateTimeCheck.isFutureTime,
                hasFutureDate: futureDateTimeCheck.isFutureDate
            });
        }

        let locationSet = await this.props.dispatchLocation(lat, lng);
        if (this.state.selectedCover !== undefined && (this.props.claimSubmit.selectedCover.product === 1 || this.props.claimSubmit.selectedCover.product === 7) && (!this.state.hasFutureDate && !this.state.hasFutureTime)) {

            await this.setState({
                IsIncidentDateValidationVisible: this.props.claimSubmit.incidentDate === "",
                incidentDescriptionValidationVisible: this.state.incidentDescription === "",
                hasTimeChanged: this.props.claimSubmit.time === "",
                nameValidationVisible: (await validateSurname.test(this.state.name) !== true),
                contactValidationVisible: (await validateCellphoneNumber.test(this.state.contact) !== true),
                carRecoveredValidationVisible: (!this.state.carRecoveredSet),
                carDriveableValidationVisible: (!this.state.carDriveableSet),
            });

            if (this.props.claimSubmit.incidentEventType.id === 999) {
                await this.setState({
                    selectedIncidentTypeValidationVisible: true,
                });
            }

            if (!(this.state.selectedIncidentTypeValidationVisible || this.state.incidentDescriptionValidationVisible || this.state.hasTimeChanged ||
                this.state.nameValidationVisible || this.state.contactValidationVisible ||
                this.state.carRecoveredValidationVisible || this.state.carDriveableValidationVisible || this.state.IsIncidentDateValidationVisible)) {
                await this.Submit();
            }
        }
        else {
            await this.setState({
                IsIncidentDateValidationVisible: this.props.claimSubmit.incidentDate === "",
                incidentDescriptionValidationVisible: this.state.incidentDescription === "",
                hasTimeChanged: this.props.claimSubmit.time === "",
                nameValidationVisible: (await validateSurname.test(this.state.name) !== true),
                contactValidationVisible: (await validateCellphoneNumber.test(this.state.contact) !== true),
            });

            if (this.props.claimSubmit.incidentEventType.id === 999) {
                await this.setState({
                    selectedIncidentTypeValidationVisible: true,
                });
            }

            if (!(this.state.selectedIncidentTypeValidationVisible || this.state.incidentDescriptionValidationVisible || this.state.hasTimeChanged ||
                this.state.nameValidationVisible || this.state.contactValidationVisible || this.state.IsIncidentDateValidationVisible) && (!this.state.hasFutureDate && !this.state.hasFutureTime)) {
                await this.Submit();
            }
        }
    }

    async Submit() {
        await this.setState({ isDuplicate: false });
        var postData = JSON.stringify({
            PolicyRiskItemId: this.props.claimSubmit.selectedCover.id,
            CustomerId: this.props.profile.customerId,
            IncidentType: this.props.claimSubmit.selectedEvent.id,
            Date: this.props.claimSubmit.incidentDate,
            Time: this.props.claimSubmit.time,
            CauseOfDamage: this.props.claimSubmit.selectedEvent.id,
            IsRecovered: false,
            IsGlassClaim: false,
            IsBlingClaim: false,
        });
        var duplicateClaims = await this.props.dispatchCheckDuplicateClaims(postData)
        if (duplicateClaims) {
            await this.setState({ isDuplicate: true });
            await this.props.dispatchShowDuplicateClaim();
        }
        else {
            let claimNum = await this.props.dispatchSubmitClaim(this.state);
            if (claimNum) {
                this.props.dispatchAction(showFNOLSubmitModal());
                await this.setState({ currentStep: 3 });
                this.props.redirectTo(SUBMIT_CLAIM_COMPLETE);
            }
        }
    }

    handeCanDrive(e: any) {
        if (e === "true") {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: true
            });
        }
        else {
            this.setState({
                carDriveableSet: true,
                carRecoveredSet: true,
                isDriveable: false
            });
        }

    }

    handeCanRecover(e: any) {
        if (e === "true") {
            this.setState({
                carRecoveredSet: true,
                carDriveableSet: true,
                isRecovered: true
            });
        }
        else {
            this.setState({
                carRecoveredSet: true,
                carDriveableSet: true,
                isRecovered: false
            });
        }
    }

    handleIndidentDateClicked() {
        document.body.addEventListener("click", this.handleClickAway);
        this.setState({
            isClosed: false,
        })
    }

    async mapReady(mapProps, map) {
        let lat = map.center.lat();
        let lng = map.center.lng();
        await this.setState({ lat: lat, lng: lng })
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng
            Geocode.fromLatLng(lat, lng).then(
                (response) => {
                    let streetNumber, streetName, suburb, city, state, country, postal_code;
                    const address = response.results[0];
                    for (let i = 0; i < address.address_components.length; i++) {
                        for (let j = 0; j < address.address_components[i].types.length; j++) {
                            switch (address.address_components[i].types[j]) {
                                case "street_number":
                                    streetNumber = address.address_components[i].long_name;
                                    break;
                                case "route":
                                    streetName = address.address_components[i].long_name;
                                    break;
                                case "sublocality":
                                    suburb = address.address_components[i].long_name;
                                    break;
                                case "locality":
                                    city = address.address_components[i].long_name;
                                    break;
                                case "administrative_area_level_1":
                                    state = address.address_components[i].long_name;
                                    break;
                                case "country":
                                    country = address.address_components[i].long_name;
                                    break;
                                case "postal_code":
                                    postal_code = address.address_components[i].long_name;
                                    break;
                            }
                        }
                    }

                    let addressDetails = { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted: address.formatted_address, postalCode: postal_code?.toUpperCase() };
                    this.setState({ lat: lat, lng: lng, addressSelect: address.formatted_address, addressDetail: addressDetails });
                    this.updateLatLngAdress(lat, lng, address, addressDetails);
                })
        })
    }

    async handleClick(e: any) {
        await this.getIncidentTypes(e.target.id);
    }

    async handleNext(e: any) {
        await this.setState({ currentStep: 2 });
    }

    async handleNextMobile(e: any) {
        this.props.redirectTo(SUBMIT_CLAIM_DETAILS);
    }


    async getIncidentTypes(riskItemId) {
        await postToController(this.props.dispatch, 'GetEventTypes', JSON.stringify({ Parameter: riskItemId })).then(async (response) => {
            await this.setState({ eventTypeList: response });
            return true;
        })
    }


    async handleCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.getIncidentTypes(coverItem[0].id)
        await this.setState({ selectedCover: coverItem[0], selectedEvent: [] });
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    async handleRedirect() {
        await this.props.dispatchResetFNOL();
        await this.props.dispatchClearSelectedDamages();
        await this.props.dispatchSetStep(1, 1)
        await this.props.redirectTo(FNOL_SUBMIT_CLAIM);
    }

    async handleIncidentTypeDropdownToggle(e: any) {
        await this.setState({
            IncidentTypeToggle: !this.state.IncidentTypeToggle
        });
    }

    async handleIncidentSelection(e: any) {
        let eventType = this.state.eventTypeList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedIncidentType: eventType[0] });
        await this.setState({ nextDisabled: false });
    }

    async handleIncidentEventTypeSelection(e: any) {
        let incidentType = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedIncidentType: incidentType[0] });
    }

    async handleIncidentToggle(e: any) {
        await this.setState({
            IncidentToggle: !this.state.IncidentToggle
        });
    }

    public render() {
        let incidentEventTypes = <div></div>;
        incidentEventTypes = this.props.claimSubmit.incidentEventList.map((event) => {
            return <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                {event.description}
            </Dropdown.Item>
        });

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: FNOL, description: "Claims" }]

        return (
            <div >
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Submit a claim" />
                <div className="submit-a-claim-history-block mb-5">
                    <div className="container" id="SubmitClaim">
                        <h3 className="claim-title pt-3 mb-1">Claim details</h3>
                        <hr />
                        <div className="mb-4" onClick={this.checkTimeToggle}>
                            <p className={this.state.IsIncidentDateValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                            <p className="mb-1">Incident date</p>
                            <DatePicker />
                            {!this.state.IsIncidentDateValidationVisible && this.state.hasFutureDate &&
                                <div className="form-inline-error">The date should not be in the future</div>
                            }
                        </div>
                        {this.props.claimSubmit.timeDisplay &&
                            <div className={'form-group mb-3 pt-4"' + (this.state.stepSubmitted && !this.state.hasTime ? ' has-error' : '')}>
                                <p className={this.state.hasTimeChanged === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                                <label className={'form-label' + (this.props.claimSubmit.timeDisplay ? "" : " no-opacity")}>Incident time</label>
                                <input type="button" disabled={this.props.isClosed} className="form-control clientName pl-0 text-left watch-inline-icon" value={this.props.claimSubmit.timeDisplay ? this.props.claimSubmit.timeDisplay : 'Select incident time'} onClick={this.handleIndidentDateClicked} />
                                <div className={this.props.claimSubmit.IsIncidentDateClicked ? 'visible' : 'invisible'} onMouseLeave={this.setMouseOut} onMouseEnter={this.setMouseIn}>
                                    <div>
                                        <TimeKeeper
                                            time={this.props.claimSubmit.timeDisplay}
                                            switchToMinuteOnHourSelect
                                            onChange={(newTime) => this.handleTimeChange(newTime.formatted12, newTime.formatted24)}
                                            doneButton={(newTime) => (
                                                <div
                                                    className="btn btn-solid-red process"
                                                    onClick={() => this.setTime(newTime.formatted12, newTime.formatted24)}
                                                >
                                                    Close
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            {this.state.stepSubmitted && !this.state.hasTime &&
                                    <div className="help-block">Time is required</div>
                                }
                                {!this.state.hasTime && this.state.hasFutureTime &&
                                    <div className="form-inline-error">The time should not be in the future</div>
                                }

                            </div>}
                        <div className="mb-5">
                            <p className={this.state.incidentDescriptionValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                            <p>Tell us what happened</p>
                            <textarea id="incidentDescription" name="incidentDescription" rows={4} cols={50} className="form-control w3review" placeholder="Click here to start typing" value={this.state.incidentDescription} onChange={this.handleChange} />
                        </div>
                        {this.props.claimSubmit.selectedCover !== undefined && (this.props.claimSubmit.selectedCover.product === 1 || this.props.claimSubmit.selectedCover.product === 7) &&
                            <>
                                <div id="GoogleMap" className="pt-3">
                                    <p className="mb-1">Where did the incident happen</p>
                                    <div>
                                        <PlacesAutocomplete
                                            value={this.state.adressSelect}
                                            onChange={this.handleAdressChange}
                                            onSelect={this.handleAdressSelect}
                                            searchOptions={{ componentRestrictions: { country: this.props.profile.googleMapsCountryCode } }}
                                        >
                                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                <div>
                                                    <input
                                                        {...getInputProps({
                                                            placeholder: 'Search location...',
                                                            className: ' searchbox mb-1',
                                                        })}
                                                    />
                                                    <div className="autocomplete-dropdown-container">
                                                        {loading && <div>Loading...</div>}
                                                        {suggestions.map(suggestion => {
                                                            const className = suggestion.active
                                                                ? 'suggestion-item--active'
                                                                : 'suggestion-item';
                                                            // inline style for demonstration purpose
                                                            const style = suggestion.active
                                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                            return (
                                                                <div
                                                                    {...getSuggestionItemProps(suggestion, {
                                                                        className,
                                                                        style,
                                                                    })}
                                                                >
                                                                    <span>{suggestion.description}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </PlacesAutocomplete>
                                    </div>
                                    <Map google={this.props.google}
                                        centerAroundCurrentLocation
                                        center={{ lat: this.state.lat, lng: this.state.lng }}
                                        onReady={this.mapReady}
                                        containerStyle={{
                                            position: 'relative',
                                            overflow: 'hidden',
                                            width: '100%',
                                            height: '271px'
                                        }}>
                                        <Marker
                                            // @ts-ignore
                                            position={{ lat: this.state.lat, lng: this.state.lng }}
                                            draggable={false}
                                            title="Accident location"
                                        />
                                    </Map>
                                </div>
                                {this.props.claimSubmit.selectedEvent.description !== "Theft" &&
                                    <div className="mb-3 mt-2">
                                        <p className={this.state.carDriveableValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                                        <p className="mt-3 mb-1">Is your vehicle still drivable</p>
                                        <Dropdown id="CarDrivable"
                                            onSelect={this.handeCanDrive}>
                                            <Dropdown.Toggle id="dropdown-basic" >
                                                {this.state.carDriveableSet &&
                                                    <>
                                                        <p className="title mb-1"></p>
                                                        <p className="hide-overflow p-nomargin">{this.state.isDriveable === true ? "Yes" : "No"}</p>
                                                    </>
                                                }
                                                {!this.state.carDriveableSet &&
                                                    <p>Select vehicle drivable</p>
                                                }
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                <Dropdown.Item eventKey={"true"} key="true" value="Yes">Yes</Dropdown.Item>
                                                <Dropdown.Item eventKey={"false"} key="false" value="No">No</Dropdown.Item>
                                            </Dropdown.Menu>
                                            <hr />
                                        </Dropdown>
                                    </div>
                                }
                                {this.props.claimSubmit.selectedEvent.description === "Theft" &&
                                    <>
                                        <div className="mb-3 mt-3">
                                            <p className={this.state.carRecoveredValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                                            <p className="mb-1">Was the vehicle recovered</p>
                                            <Dropdown id="CarRecovered"
                                                onSelect={this.handeCanRecover}>
                                                <Dropdown.Toggle id="dropdown-basic" >
                                                    {this.state.carRecoveredSet &&
                                                        <>
                                                            <p className="title mb-1"></p>
                                                            <p className="p-nomargin">{this.state.isRecovered === true ? "Yes" : "No"}</p>
                                                        </>
                                                    }
                                                    {!this.state.carRecoveredSet &&
                                                        <p>Select vehicle recovered</p>
                                                    }
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                    <Dropdown.Item eventKey={"true"} key="true" value="Yes">Yes</Dropdown.Item>
                                                    <Dropdown.Item eventKey={"false"} key="false" value="No">No</Dropdown.Item>
                                                </Dropdown.Menu>
                                                <hr />
                                            </Dropdown>
                                        </div>
                                        {this.state.isRecovered === true &&
                                            <div className="mb-3">
                                                <p className={this.state.carDriveableValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                                                <p className="mt-3 mb-1">Is your vehicle still drivable</p>
                                                <Dropdown id="CarDrivable"
                                                    onSelect={this.handeCanDrive}>
                                                    <Dropdown.Toggle id="dropdown-basic" >
                                                        {this.state.carDriveableSet &&
                                                            <>
                                                                <p className="title mb-1"></p>
                                                                <p className="p-nomargin">{this.state.isDriveable === true ? "Yes" : "No"}</p>
                                                            </>
                                                        }
                                                        {!this.state.carDriveableSet &&
                                                            <p>Select vehicle drivable</p>
                                                        }
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                        <Dropdown.Item eventKey={"true"} key="true" value="Yes">Yes</Dropdown.Item>
                                                        <Dropdown.Item eventKey={"false"} key="false" value="No">No</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                    <hr />
                                                </Dropdown>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        }
                        <div className="mb-3">
                            <p className={this.state.nameValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                            <p className="mb-1">Name</p>
                            <input className="form-control clientName pl-0" name="name" value={this.state.name} onChange={this.handleChange} />
                        </div>
                        <div className="mb-5">
                            <p className={this.state.contactValidationVisible === true ? "help-block mb-2" : "help-block mb-2 invisible"}>*Required</p>
                            <p className="mb-1">Contact no.</p>
                            <input className="form-control clientName pl-0" name="contact" value={this.state.contact} onChange={this.handleChange} />
                        </div>
                        <div>
                            <button className="btn btn-outline-red mr-2 mb-3 mb-sm-3" onClick={this.handleRedirect}>Back</button>
                            <button className="btn btn-solid-red mb-3 mb-sm-3" disabled={this.state.submitDisabled} onClick={this.handleSubmit}>Submit claim</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSubmitClaim: (data) => dispatch(submitClaimMobile(data)),
        dispatchLocation: (lat, lng) => dispatch(setLocation(lat, lng)),
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchShowDuplicateClaim: () => dispatch(showDuplicateClaim()),
        dispatchCheckDuplicateClaims: (data) => dispatch(checkDuplicateClaim(data)),
        dispatchSetTime: (time12, time24) => dispatch(setTime(time12, time24)),
        dispatchClearSelectedDamages: () => dispatch(clearSelectedDamages()),
        dispatchResetFNOL: () => dispatch(resetFNOL()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchAction: (e) => dispatch(e)
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(ClaimDetails);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);